/** Format a betting odd for on-screen display (always two decimal places). */
export function formatOddForDisplay(value: number): string {
  if (!Number.isFinite(value) || value <= 0) return '—';
  return (Math.round(value * 100) / 100).toFixed(2);
}
